import { createAsyncThunk } from "@reduxjs/toolkit";
import organizationService from "../../../api/services/organization";

export const fetchUserInfo = createAsyncThunk(
  "organization/fetch-user-info",
  async (requestData) => {
    return await organizationService.fetchInfo(requestData);
  }
);

export const setOrganizationDescription = createAsyncThunk(
  "organization/set-organization-description",
  async (requestData) => {
    return await organizationService.setOrganizationDescription(requestData);
  }
);

export const setActiveUserOrganization = createAsyncThunk(
  "organization/set-active-user-organization",
  async (organizationId) => {
    return await organizationService.setActiveUserOrganization(organizationId);
  }
);

export const setOrganizationLogo = createAsyncThunk(
  "organization/set-organization-logo",
  async ({ file, organizationId }) => {
    let formData = new FormData();
    if (file) {
      formData.append("file", file);
    }
    formData.append("organizationId", organizationId);

    return await organizationService.setOrganizationLogo(formData);
  }
);

export const getOrganizationMembers = createAsyncThunk(
  "organization/get-organization-members",
  async ({ page }) => {
    if (!page) {
      page = 1;
    }
    return await organizationService.getOrganizationMembers(page);
  }
);

export const searchUsers = createAsyncThunk(
  "organization/search-users",
  async ({ page, search }) => {
    if (!page) {
      page = 1;
    }
    return await organizationService.searchUsers(page, search);
  }
);

export const addMemberToOrganization = createAsyncThunk(
  "organization/add-member-to-organization",
  async (requestData) => {
    return await organizationService.addMemberToOrganization(requestData);
  }
);

export const getUserMemberWishlistItems = createAsyncThunk(
  "organization/get-user-member-wishlist-items",
  async ({ id }) => {
    return await organizationService.getUserMemberWishlistItems(id);
  }
);

export const removeItemFromWishlist = createAsyncThunk(
  "organization/remove-item-from-wishlist",
  async ({ itemId }) => {
    return await organizationService.removeItemFromWishlist(itemId);
  }
);

export const updateItem = createAsyncThunk(
  "organization/updateItem",
  async ({
    id,
    engName,
    price,
    arDesc,
    engDesc,
    arName,
    uploadedPhotos,
    location,
    buyable,
    imageFiles,
  }) => {
    let formData = new FormData();
    if (uploadedPhotos.length) {
      const newPhotos = uploadedPhotos.filter(
        (photo) => !photo.includes("https")
      );
      // formData = await createMultipartArray(formData, 'files', newPhotos);
      if (Array.isArray(imageFiles)) {
        imageFiles.forEach((image) => {
          formData.append(`files`, image);
        });
      }
    }

    formData.append("id", id);
    formData.append("name", engName);
    formData.append("price", price);
    if (arDesc !== "") {
      formData.append("descriptionAr", arDesc);
    }

    if (arName !== "") {
      formData.append("nameAr", arName);
    }
    formData.append("currency", "sar");

    formData.append("photoUrls[]", []);

    for (var i = 0; i < uploadedPhotos.length; i++) {
      if (uploadedPhotos[i].includes("https")) {
        formData.append("photoUrls[]", uploadedPhotos[i]);
      }
    }

    formData.append("locationName", location.name);
    formData.append("locationLat", location.lat);
    formData.append("locationLng", location.lng);

    formData.append("description", engDesc);

    formData.append("buyable", buyable);

    // formData.append('itemPhotosLength', photosLength);

    let photoUrls = [];

    let formatedPhotos = uploadedPhotos.filter((photo) => {
      if (photo.includes("https")) {
        photoUrls.push(photo);
        return false;
      } else {
        return true;
      }
    });

    let photosLength = formatedPhotos.length;
    formData.append("itemPhotosLength", photosLength);
    return await organizationService.updateItem(formData);
  }
);
export const removeOrganization = createAsyncThunk(
  "organization/remove-organization",
  async (organizationId) => {
    return await organizationService.removeOrganization(organizationId);
  }
);

export const removeMember = createAsyncThunk(
  "organization/remove-member",
  async (memberId) => {
    return await organizationService.removeMember(memberId);
  }
);

export const addNewOrganization = createAsyncThunk(
  "organization/add-new-organization",
  async (organizationName) => {
    return await organizationService.addNewOrganization(organizationName);
  }
);

export const setPriorityToOrganizationMembers = createAsyncThunk(
  "organization/set-priority-to-organization-members",
  async (members) => {
    return await organizationService.setPriorityToOrganizationMembers(members);
  }
);

export const setPriorityToOrganizations = createAsyncThunk(
  "organization/set-priority-to-organizations",
  async (organizations) => {
    return await organizationService.setPriorityToOrganizations(organizations);
  }
);

export const editOrganizationMemberDescription = createAsyncThunk(
  "organization/set-organization-member-description",
  async (data) => {
    return await organizationService.setOrganizationMemberDescription(data);
  }
);
